import {StringRepresentation} from '../types';
import {isVersionEqual} from '../isVersionEqual';
import {parseVersion} from '../parseVersion';

export function isVersionHigher(
  versionA: StringRepresentation,
  versionB: StringRepresentation
): boolean {
  const {major: majorA, minor: minorA, patch: patchA} = parseVersion(versionA);
  const {major: majorB, minor: minorB, patch: patchB} = parseVersion(versionB);

  if (isVersionEqual(versionA, versionB)) return false;
  if (majorA > majorB) return true;
  if (majorA === majorB && minorA > minorB) return true;
  if (majorA === majorB && minorA === minorB && patchA > patchB) return true;
  return false;
}
